"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  GRADUATION: 'graduation',
  UNIVERSITY: 'university',
  EMAIL: 'email',
  PRONOUNS: 'pronouns',
  EMOJIS: 'emojis',
  EXPERIENCE: 'experience',
  PASSWORD: 'password',
  PHONE: 'phone',
  ALTERNATIVE_EMAIL: 'alternativeEmail',
  WHY_OUR_COMPANY: 'whyOurCompany'
};
exports.default = _default;